export var ADS = 'ads';
export var PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT = 'product:attributelist:showwarningvoltagetext';
export var SEARCH_PLACEHOLDER_TEXT = 'Busca no Magalu';
export var SPONSORED = 'patrocinado';
export var TYPE_FLOAT = 'typeFloat';